export const calculateDownloadSpeed = (loaded: number, downloadStartTime: number) => {
    const currentTime = Date.now();
    const timeElapsed = (currentTime - downloadStartTime) / 1000;
    const bytesPerSecond = timeElapsed > 0 ? loaded / timeElapsed : 0;
    const mbPerSecond = (bytesPerSecond / (1024 * 1024)).toFixed(1);
    return `${mbPerSecond} MB/s`;
};
export const calculateDownloadProgress = (loaded: number, total: number) => {
    return Number(((loaded / total) * 100).toFixed(2));
};
